/* eslint-disable vue/no-side-effects-in-computed-properties */
<template>
  <v-container>
    <v-dialog fullscreen v-model="waiting_dialog">
      <div class="text-center">
        <v-overlay :value="overlay">
          <v-progress-circular
            :width="3"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-overlay>
      </div>
    </v-dialog>
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-12">
        <div class="text-center mt-2">
          <v-card
            v-if="document_list.length == 0"
            class="d-flex align-center justify-center mt-4 pa-4 mx-auto mb-4"
            min-height="96"
            outlined
          >
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <div
                  class="
                    section-title
                    text-center
                    position-relative
                    pb-3
                    mx-auto
                  "
                  style=""
                >
                  <h3 class="blue-grey--text darken-1 text-center pb-4 m-3">
                    Pas de document disponible
                  </h3>
                </div>
              </v-col>
            </v-row>
          </v-card>
          <v-card
            v-if="document_list.length != 0"
            class="d-flex align-center justify-center mt-4 pa-4 mx-auto mb-4"
            min-height="96"
            outlined
          >
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <div class="text-center">La list des Documents</div>
              </v-col>
            </v-row>
          </v-card>
          <v-card
            v-if="document_list.length != 0"
            class="d-flex align-center justify-center mt-4 pa-4 mx-auto mb-4"
            min-height="96"
            outlined
          >
            <v-row no-gutters>
              <v-snackbar
                v-model="snackbar"
                :color="snackbarColor"
                :timeout="3000"
                style="z-index: 1800"
                :top="true"
              >
                {{ snackbar_text }}
              </v-snackbar>
              <v-col cols="12" class="m-2" sm="3" md="3">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date_debut"
                      label="Date de debut"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_debut"
                    @input="menu1 = false"
                    ainLayout-componentd
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="m-2" sm="3" md="3">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date_fin"
                      label="Date de debut"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_fin"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="m-2" sm="2" md="2">
                <v-btn
                  :disabled="$v.$invalid"
                  block
                  @click="search_date"
                  color="primary"
                  class="m-2"
                >
                  Filtrer
                </v-btn>
              </v-col>
              <v-col cols="12" class="m-2" sm="3" md="3">
                <v-btn
                  :disabled="cancel_search"
                  block
                  color="primary"
                  class="m-2"
                  @click="
                    cancel_search = true;
                    date_debut = null;
                    date_fin = null;
                  "
                >
                  Annuler la recherche
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </div>
        <v-col class="text-center" v-if="!cancel_search" cols="12" sm="12">
          <div style="background: #e0e0e0">
            <v-divider> </v-divider>
            <h4 style="color: #4a4343; margin-left: 10px">
              Résultat de la recherche
            </h4>
            <v-divider> </v-divider>
          </div>
        </v-col>
        <v-row>
          <v-col cols="12" v-for="item in document_list" :key="item.id">
            <document-details :document="item"> </document-details>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>
<script>
import moment from "moment";
import DocumentDetails from "../components/DetailsDocument.vue";
import { mapGetters } from "vuex";
import { i18n } from "../plugins/i18n";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "DocumentsList",

  components: {
    "document-details": DocumentDetails,
  },
  mixins: [validationMixin],
  validations: {
    date_debut: { required },
    date_fin: { required },
  },
  data: () => ({
    overlay: true,
    waiting_dialog: true,
    cancel_search: true,
    menu1: false,
    menu2: false,
    snackbar: false,
    snackbarColor: "default",
    snackbar_text: "",
    document_list: [],
    date_fin: null,
    date_debut: null,
  }),
  watch: {
    langLocal(val) {
       moment.locale(val);
    },
  },
  computed: {
    ...mapGetters(["currentrole","errors", "registered", "countries"]),
  },

  created() {
    this.$store.dispatch("getcountries");
    this.getEdocument();
    this.$store.dispatch("setCurrentRoute", this.$route.name);
    moment.locale(this.langLocal);
  },

  methods: {
    format_date(value, format) {
      if (value) {
        return moment(String(value)).format(format);
      }
    },
    async getEdocument() {
      await this.$store
        .dispatch("getEdocument")
        .then((response) => {
          if (response.success) {
            this.document_list = response.data;
          }

          this.overlay = false;
          this.waiting_dialog = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async search_date() {
      const data = new FormData();
      data.append("date_debut", this.date_debut);
      data.append("date_fin", this.date_fin);
      await this.$store
        .dispatch("getEdocumentByDate", data)
        .then((response) => {
          if (response.success) {
            this.document_list = response.data;
            this.snackbarColor = "success";
            this.snackbar_text = i18n.t("message.search_success");
            this.snackbar = true;
          } else {
            this.snackbarColor = "red";
            this.snackbar_text = i18n.t("message.error");
            this.snackbar = true;
          }
          this.cancel_search = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
